import {getFormContext} from "config/FormContext";
import {useContext, useEffect, useRef, useState} from "react";
import {InputErrorType} from "types/form-types";
import {validateInput} from "utilities/input-utilities";
import {BaseInputPropsType} from "./Input";
import InputWrapper from "./input-common/InputWrapper";

type TextareaPropsType = Omit<BaseInputPropsType<HTMLTextAreaElement, string>, 'prefix'> & {
    minLength?: number
    maxLength?: number,
    required?: boolean
    rows?: number
}

const Textarea = (props: TextareaPropsType) => {
    const input = useRef<HTMLTextAreaElement>(null);
    const inputWrapper = useRef<HTMLDivElement>(null);
    let [touched, setTouched] = useState(props.touched ? true : false);
    let [errors, setErrors] = useState<InputErrorType[]>([]);
    const formContext = getFormContext(useContext);

    useEffect(() => {
        setTouched(formContext.submitted);
        validate(!formContext.submitted);
    }, [formContext.submitted])

    const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        if (typeof props.onChange == 'function') {
            props.onChange(e.currentTarget.value, e);
        }

        if (touched) {
            validate();
        }
    };

    const onBlur = (e: React.FocusEvent<HTMLTextAreaElement>) => {
        setTouched(true);
        validate();
        if (typeof props.onBlur == 'function') {
            props.onBlur(e.currentTarget.value, e);
        }
    }

    function validate(soft?: boolean) {
        setErrors(validateInput({
            value: props.value,
            input: input?.current || undefined,
            inputWrapper: inputWrapper?.current || undefined,
            customErrors: props.customErrors,
            soft: soft ? true : false
        }) || []);
    }

    return (
        <InputWrapper
            errors={errors}
            inputWrapperRef={inputWrapper}
            label={props.label}
            className="px-2"
            required={props.required}
        >
            <textarea
                ref={input}
                className="bg-inherit text-inherit w-full"
                value={props.value || ''}
                onChange={onChange}
                onBlur={onBlur}
                placeholder={props.placeholder}
                name={props.name}
                id={props.id}
                rows={props.rows || 5}
                minLength={props.minLength}
                maxLength={props.maxLength}
            >
                
            </textarea>
        </InputWrapper>
    );
}

export default Textarea;
